import { CurrencyMasterService } from "@/api/services/masterService";
import { createSlice, createAsyncThunk, PayloadAction } from "@reduxjs/toolkit";

// Define types for currency
interface Currency {
  id: string; 
  currency: string; 
  countryId: string; 
  isd: string; 
  flM8Cd: string; 

}

// Define state type
interface CurrencyMasterState {
  loading: boolean;
  currencyList: Currency[];
  error?: string;
}

// Initial state with type safety
const initialState: CurrencyMasterState = {
  loading: false,
  currencyList: [],
  error: undefined,
};

// ✅ Fixed Async thunk with proper return type
export const fetchCurrencyMaster = createAsyncThunk<
  Currency[], 
  void, 
  { rejectValue: string }
>(
  "currency/fetchCurrencyMaster",
  async (_, { rejectWithValue }) => {

    try {
      const response = await CurrencyMasterService.getCurrencyMaster();

      // If API returns { data: Currency[] }, extract `data`
      return response.data ? response.data : response;
    } catch (error: any) {
      return rejectWithValue(error.message || "Failed to fetch currency data");
    }
  }
);

// Create slice with strong typing
const currencyMasterSlice = createSlice({
  name: "currencyMaster",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchCurrencyMaster.pending, (state) => {
        state.loading = true;
        state.error = undefined;
      })
      .addCase(fetchCurrencyMaster.fulfilled, (state, action: PayloadAction<Currency[]>) => {
        state.currencyList = action.payload;
        state.loading = false;
      })
      .addCase(fetchCurrencyMaster.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || "Something went wrong";
      });
  },
});

// Export reducer
export default currencyMasterSlice.reducer;
